module.exports = __webpack_public_path__ + "img/이수역 미용실.83b91ad8.png";